/* eslint-disable no-unused-vars */
import { createReducer } from '@reduxjs/toolkit';
import {
  changePasswordFailure,
  changePasswordStarted,
  changePasswordSucceeded,
  setUser,
  setUserPreferences,
} from '../../actions/user';

const UserReducer = createReducer(window.ecom.redux_initial_state.user, {
  [setUser]: (state, action) => action?.payload,
  [changePasswordStarted]: (state, action) => {
    state.changePasswordStatus = 'updating';
    state.changePasswordErrorMessage = '';
  },
  [changePasswordSucceeded]: (state, action) => {
    state.changePasswordStatus = 'succeeded';
    state.changePasswordErrorMessage = '';
  },
  [changePasswordFailure]: (state, action) => {
    state.changePasswordStatus = 'failed';
    state.changePasswordErrorMessage = action.payload;
  },
  [setUserPreferences]: (state, action) => {
    state.preferences = action.payload;
  },
});
export default UserReducer;
